import Analytics20 from '@carbon/icons-react/es/analytics/20';
import Information16 from '@carbon/icons-react/es/information/16';
import StarReview32 from '@carbon/icons-react/es/star--review/32';
import Task32 from '@carbon/icons-react/es/task/32';
import Template32 from '@carbon/icons-react/es/template/32';
import Timer32 from '@carbon/icons-react/es/timer/32';
import UserData32 from '@carbon/icons-react/es/user--data/32';
import { Col, Row as AntRow, Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as OperationalInsight } from 'assets/svgs/operational-metrics.svg';
import { CardLink as Card } from 'components/molecules/card-link';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { Text03 } from 'components/styles';
import { RoutePaths } from 'constant';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';

const Row = styled(AntRow)`
  margin-bottom: var(--layout-02);
`;
const Icon = styled.div`
  ${Text03};
`;

const CardLink = styled(Card).attrs({ hoverable: true })``;

const PageWrapper = styled.div`
  padding: var(--spacing-11) var(--spacing-05) var(--spacing-05)
    var(--spacing-12);
`;

const DangerMessage = styled.div`
  color: var(--red-60);
`;

const TimesheetFooter = styled.div`
  display: flex;
  gap: 4px;
  color: var(--gray-40);
`;

export const ReportsListPage: FC = () => {
  const [isTimesheetFeatureEnabled] = useAccountFeature(
    AccountFeature.Timesheets,
  );

  return (
    <Page $gray>
      <Page.Header
        sticky
        title={
          <HeaderWithIconTitle
            icon={<Analytics20 />}
            title={<FormattedMessage id="reports" />}
          />
        }
      />
      <Page.Content>
        <PageWrapper>
          <Row gutter={24}>
            <Col span={8}>
              <CardLink
                link={{ to: RoutePaths.csatReports }}
                title={<FormattedMessage id="reports.csat.title" />}
                description={<FormattedMessage id="reports.csat.description" />}
                icon={
                  <Icon>
                    <StarReview32 />
                  </Icon>
                }
              />
            </Col>
            <Col span={8}>
              <CardLink
                link={{ to: RoutePaths.timesheetReports }}
                title={<FormattedMessage id="reports.timesheets.title" />}
                description={
                  <FormattedMessage id="reports.timesheets.description" />
                }
                icon={
                  <Icon>
                    <Timer32 />
                  </Icon>
                }
                footerDescription={
                  isTimesheetFeatureEnabled ? null : (
                    <TimesheetFooter>
                      <DangerMessage>
                        <FormattedMessage id="timesheets.reports.timesheet_disabled" />
                      </DangerMessage>
                      <Tooltip
                        title={
                          <FormattedMessage id="timesheets.reports.timesheet_disabled_tooltip" />
                        }
                      >
                        <Information16 />
                      </Tooltip>
                    </TimesheetFooter>
                  )
                }
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <CardLink
                link={{ to: RoutePaths.projectsReport }}
                title={
                  <FormattedMessage id="reports.project_performance.title" />
                }
                description={
                  <FormattedMessage id="reports.project_performance.description" />
                }
                icon={
                  <Icon>
                    <Task32 />
                  </Icon>
                }
              />
            </Col>
            <Col span={8}>
              <CardLink
                link={{ to: RoutePaths.usersReport }}
                title={
                  <FormattedMessage id="reports.users_performance.title" />
                }
                description={
                  <FormattedMessage id="reports.users_performance.description" />
                }
                icon={
                  <Icon>
                    <UserData32 />
                  </Icon>
                }
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <CardLink
                link={{ to: RoutePaths.templateInsight }}
                title={<FormattedMessage id="reports.template_insight.title" />}
                description={
                  <FormattedMessage id="reports.template_insight.description" />
                }
                icon={
                  <Icon>
                    <Template32 />
                  </Icon>
                }
              />
            </Col>
            <Col span={8}>
              <CardLink
                link={{ to: RoutePaths.intervalsReport }}
                title={<FormattedMessage id="reports.intervals.title" />}
                description={
                  <FormattedMessage id="reports.intervals.description" />
                }
                icon={<OperationalInsight />}
              />
            </Col>
          </Row>
        </PageWrapper>
      </Page.Content>
    </Page>
  );
};
